module.exports = __webpack_public_path__ + "img/banner_img_2.fb713ef1.png";